// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"_20YQXgEvgR2wKw7n_f11SP"};